import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '../utils/helpers'

const Select = forwardRef(({ 
  label, 
  error, 
  options = [],
  placeholder,
  className = '', 
  ...props 
}, ref) => {
  const { t } = useTranslation()
  const normalizedOptions = options.map((option) =>
    typeof option === 'string'
      ? { label: option, value: option }
      : option
  )

  const defaultPlaceholder = placeholder || (label ? t('common.labels.select') + ' ' + label : t('common.labels.select'))

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        ref={ref}
        className={cn('input-field', error && 'border-red-400 focus:border-red-500 focus:ring-red-200', className)}
        {...props}
      >
        <option value="">{defaultPlaceholder}</option>
        {normalizedOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select

